<script setup>
import UserCard from "../components/UserCard.vue";
import PreFacturaTable from "../components/pre-factura/PreFacturaTable.vue";
import PreFacturaModal from "../components/pre-factura/PreFacturaModal.vue"; 
import bootstrap from "bootstrap/dist/js/bootstrap";

const addNewPrefactura = () => {
  const modal = new bootstrap.Modal(document.getElementById('prefacturaModal'));
  modal.show();
};
</script>

<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12 mb-lg" style="margin-top: 10%;">
        <user-card></user-card>
        <div class="d-flex justify-content-end mb-3">
          <button class="btn btn-outline-success btn-sm" @click="addNewPrefactura">
            <i class="fas fa-plus me-2"></i>Agregar Nueva Pre-Factura
          </button>
        </div>
        <PreFacturaTable></PreFacturaTable>
      </div>
    </div>
  </div>

  <PreFacturaModal />
</template>

<style scoped>
.btn-outline-success {
  color: #28a745;
  border-color: #28a745;
}
.btn-outline-success:hover {
  background-color: #28a745;
  color: white;
}
</style>
